"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=doctor-master.dto.js.map